import React, { useEffect } from 'react';
import './CopyrightModal.css';

export const CopyrightModalGKH = ({ isOpen, onClose }) => {
  // Данные для компании ЖКХ-Инфо из таблицы
  const gkhData = {
    fullName: "Общество с ограниченной ответственностью «ЖКХ ИНФО КРАСНОЯРСК»",
    address: "Россия, 660135, Красноярский край, г. Красноярск, ул. Взлетная, д.7А, пом.164",
    inn: "2465333775",
    okved: "62.01",
    email: "mpsupport@kras-abs.ru",
    phone: "+7 (902) 926-88-24",
    website: "https://gkh-info.org",
    itCodes: "1.01, 1.02 и 1.05",
    
    // Пункт 9: Описание товаров/услуг и стоимость
    productsDescription: "уточняется",
    
    // Пункт 10: Исключительные права
    hasExclusiveRights: true,
    softwareName: "ЖКХ.Инфо",
    registrationNumber: "2024611636",
    registrationDate: "23.01.2024",
    rightsHolder: "ООО «ЖКХ ИНФО КРАСНОЯРСК» (RU)",
    registryLink: "https://fips.ru/",
    
    // Пункт 11: Технологический стек
    programmingLanguages: "GoLang, TypeScript/JavaScript, Kotlin, Swift",
    software: "Figma, Node.js",
    toolsFrameworks: "React, Swagger",
    
    // Пункт 12: Реестр российских программ
    inRussianRegistry: false,
    programIdentification: "уточняется",
    distributionMethods: "уточняется"
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        
        <div className="copyright-text">
          <h1>Информация о правообладателе</h1>
          
          <div className="info-section">
            <h2>1. Общие сведения</h2>
            <p>Полное наименование организации: {gkhData.fullName}</p>
            <p>Адрес организации: {gkhData.address}</p>
            <p>ИНН налогоплательщика: {gkhData.inn}</p>
            <p>Основной код по ОКВЭД: {gkhData.okved}</p>
          </div>
          
          <div className="info-section">
            <h2>2. Контактная информация</h2>
            <p>Адрес электронной почты: <a href={`mailto:${gkhData.email}`}>{gkhData.email}</a></p>
            <p>Номер телефона организации: <a href={`tel:${gkhData.phone.replace(/\s/g, '')}`}>{gkhData.phone}</a></p>
            <p>Официальный сайт: <a href={gkhData.website} target="_blank" rel="noopener noreferrer">{gkhData.website}</a></p>
          </div>
          
          <div className="info-section">
            <h2>3. Деятельность в области ИТ</h2>
            <p>Код (коды) вида (видов) деятельности в области ИТ-технологий: {gkhData.itCodes}</p>
          </div>
          
          {/* <div className="info-section">
            <h2>4. Описание реализуемых товаров, работ и услуг</h2>
            <p>Описание товаров, работ, услуг и их стоимость: {gkhData.productsDescription}</p>
          </div> */}
          
          <div className="info-section">
            <h2>5. Исключительные права на программное обеспечение</h2>
            <p>Наличие исключительных прав: Да</p>
            <p>Название программного продукта: {gkhData.softwareName}</p>
            <p>Номер регистрации (свидетельства): {gkhData.registrationNumber}</p>
            <p>Дата регистрации: {gkhData.registrationDate}</p>
            <p>Правообладатель: {gkhData.rightsHolder}</p>
            <p>Ссылка на реестр: <a href={gkhData.registryLink} target="_blank" rel="noopener noreferrer">{gkhData.registryLink}</a></p>
          </div>
          
          <div className="info-section">
            <h2>6. Технологический стек</h2>
            <p>Используемые языки программирования: {gkhData.programmingLanguages}</p>
            <p>Используемое программное обеспечение: {gkhData.software}</p>
            <p>Используемые наборы правил и инструментов: {gkhData.toolsFrameworks}</p>
          </div>
          
          {/* <div className="info-section">
            <h2>7. Реестр российских программ</h2>
            <p>Наличие в едином реестре российских программ: {gkhData.inRussianRegistry ? "Да" : "Нет"}</p>
            {gkhData.inRussianRegistry && (
              <>
                <p>Идентификационная информация программы: {gkhData.programIdentification}</p>
                <p>Способы реализации (распространения) ПО: {gkhData.distributionMethods}</p>
              </>
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};